const predefinedRows = [
  {
    fieldName: "queue",
    dataType: "Integer",
  },
  {
    fieldName: "pinCode",
    dataType: "String",
  },
  {
    fieldName: "state",
    dataType: "String",
  },
  {
    fieldName: "city",
    dataType: "String",
  },
  {
    fieldName: "address",
    dataType: "String",
  },
  {
    fieldName: "emailId",
    dataType: "String",
  },
  {
    fieldName: "isDisabled",
    dataType: "Boolean",
  },
  {
    fieldName: "description",
    dataType: "String",
  },
  {
    fieldName: "nation",
    dataType: "String",
  },
  {
    fieldName: "hPhone",
    dataType: "String",
  },
  {
    fieldName: "hMob",
    dataType: "String",
  },
  {
    fieldName: "ofAddr",
    dataType: "String",
  },
  {
    fieldName: "ofPhone",
    dataType: "String",
  },
  {
    fieldName: "ofMob",
    dataType: "String",
  },
  {
    fieldName: "ofFax",
    dataType: "String",
  },
  {
    fieldName: "suggestion",
    dataType: "String",
  },
  {
    fieldName: "complaint",
    dataType: "String",
  },
  {
    fieldName: "branchCode",
    dataType: "String",
  },
  {
    fieldName: "customerRelation",
    dataType: "String",
  },
  {
    fieldName: "name",
    dataType: "String",
  },
  {
    fieldName: "department",
    dataType: "String",
  },
  {
    fieldName: "purchaseDate",
    dataType: "String",
  },
  {
    fieldName: "amount",
    dataType: "String",
  },
  {
    fieldName: "isDnd",
    dataType: "Boolean",
  },
  {
    fieldName: "gender",
    dataType: "String",
  },
  {
    fieldName: "remarks",
    dataType: "String",
  },
  {
    fieldName: "accountNo",
    dataType: "String",
  },
  {
    fieldName: "secondAlternateNo",
    dataType: "String",
  },
  {
    fieldName: "alternateNo",
    dataType: "String",
  },
  {
    fieldName: "disposition",
    dataType: "String",
  },
  {
    fieldName: "accountPoints",
    dataType: "String",
  },
  {
    fieldName: "customFldC01",
    dataType: "String",
  },
  {
    fieldName: "customFldC02",
    dataType: "String",
  },
  {
    fieldName: "customFldC03",
    dataType: "String",
  },
  {
    fieldName: "customFldC04",
    dataType: "String",
  },
  {
    fieldName: "customFldC05",
    dataType: "String",
  },
  {
    fieldName: "customFldC06",
    dataType: "String",
  },
  {
    fieldName: "customFldC07",
    dataType: "String",
  },
  {
    fieldName: "customFldC08",
    dataType: "String",
  },
  {
    fieldName: "customFldC09",
    dataType: "String",
  },
  {
    fieldName: "customFldC10",
    dataType: "String",
  },
  {
    fieldName: "customFldC11",
    dataType: "String",
  },
  {
    fieldName: "customFldC12",
    dataType: "String",
  },
  {
    fieldName: "customFldC13",
    dataType: "String",
  },
  {
    fieldName: "customFldC14",
    dataType: "String",
  },
  {
    fieldName: "customFldC15",
    dataType: "String",
  },
  {
    fieldName: "customFldC16",
    dataType: "String",
  },
  {
    fieldName: "customFldC17",
    dataType: "String",
  },
  {
    fieldName: "customFldC18",
    dataType: "String",
  },
  {
    fieldName: "customFldC19",
    dataType: "String",
  },
  {
    fieldName: "customFldC20",
    dataType: "String",
  },
  {
    fieldName: "customFldC21",
    dataType: "String",
  },
  {
    fieldName: "customFldC22",
    dataType: "String",
  },
  {
    fieldName: "customFldC23",
    dataType: "String",
  },
  {
    fieldName: "customFldC24",
    dataType: "String",
  },
  {
    fieldName: "customFldC25",
    dataType: "String",
  },
  {
    fieldName: "customFldC26",
    dataType: "String",
  },
  {
    fieldName: "customFldC27",
    dataType: "String",
  },
  {
    fieldName: "customFldC28",
    dataType: "String",
  },
  {
    fieldName: "customFldC29",
    dataType: "String",
  },
  {
    fieldName: "customFldC30",
    dataType: "String",
  },
  {
    fieldName: "customFldC31",
    dataType: "String",
  },
  {
    fieldName: "customFldC32",
    dataType: "String",
  },
  {
    fieldName: "customFldC33",
    dataType: "String",
  },
  {
    fieldName: "customFldC35",
    dataType: "String",
  },
  {
    fieldName: "customFldC34",
    dataType: "String",
  },
  {
    fieldName: "customFldC36",
    dataType: "String",
  },
  {
    fieldName: "customFldC37",
    dataType: "String",
  },
  {
    fieldName: "customFldC38",
    dataType: "String",
  },
  {
    fieldName: "customFldC39",
    dataType: "String",
  },
  {
    fieldName: "customFldC40",
    dataType: "String",
  },
  {
    fieldName: "customFldC41",
    dataType: "String",
  },
  {
    fieldName: "customFldC42",
    dataType: "String",
  },
  {
    fieldName: "customFldC43",
    dataType: "String",
  },
  {
    fieldName: "customFldC44",
    dataType: "String",
  },
  {
    fieldName: "customFldC45",
    dataType: "String",
  },
  {
    fieldName: "customFldC46",
    dataType: "String",
  },
  {
    fieldName: "customFldC47",
    dataType: "String",
  },
  {
    fieldName: "customFldC48",
    dataType: "String",
  },
  {
    fieldName: "customFldC49",
    dataType: "String",
  },
  {
    fieldName: "customFldC50",
    dataType: "String",
  },
  {
    fieldName: "customFldC51",
    dataType: "String",
  },
  {
    fieldName: "customFldC52",
    dataType: "String",
  },
  {
    fieldName: "customFldC53",
    dataType: "String",
  },
  {
    fieldName: "customFldC54",
    dataType: "String",
  },
  {
    fieldName: "customFldC56",
    dataType: "String",
  },
  {
    fieldName: "customFldC55",
    dataType: "String",
  },
  {
    fieldName: "customFldC57",
    dataType: "String",
  },
  {
    fieldName: "customFldC58",
    dataType: "String",
  },
  {
    fieldName: "customFldC59",
    dataType: "String",
  },
  {
    fieldName: "customFldC60",
    dataType: "String",
  },
  {
    fieldName: "fathHusBName",
    dataType: "String",
  },
  {
    fieldName: "lHouseNo",
    dataType: "String",
  },
  {
    fieldName: "lStreet",
    dataType: "String",
  },
  {
    fieldName: "lLocality",
    dataType: "String",
  },
  {
    fieldName: "lPin",
    dataType: "String",
  },
  {
    fieldName: "pHouseNo",
    dataType: "String",
  },
  {
    fieldName: "pStreet",
    dataType: "String",
  },
  {
    fieldName: "pLocality",
    dataType: "String",
  },
  {
    fieldName: "pCity",
    dataType: "String",
  },
  {
    fieldName: "pState",
    dataType: "String",
  },
  {
    fieldName: "pPin",
    dataType: "String",
  },
  {
    fieldName: "dataUploadSource",
    dataType: "String",
  },
  {
    fieldName: "dataUploadedBy",
    dataType: "String",
  },
  {
    fieldName: "birthDate",
    dataType: "String",
  },
  {
    fieldName: "assignedAgent",
    dataType: "String",
  },
  {
    fieldName: "koId",
    dataType: "String",
  },
  {
    fieldName: "promoCode",
    dataType: "String",
  },
  {
    fieldName: "sessionUuid",
    dataType: "String",
  },
  {
    fieldName: "uuid",
    dataType: "String",
  },
  {
    fieldName: "valueType",
    dataType: "String",
  },
  {
    fieldName: "recordLastModifiedOn",
    dataType: "LocalDateTime",
  },
  {
    fieldName: "customFldN01",
    dataType: "Double",
  },
  {
    fieldName: "customFldN02",
    dataType: "Double",
  },
  {
    fieldName: "customFldN03",
    dataType: "Double",
  },
  {
    fieldName: "customFldN04",
    dataType: "Double",
  },
  {
    fieldName: "customFldN05",
    dataType: "Double",
  },
  {
    fieldName: "customFldN06",
    dataType: "Double",
  },
  {
    fieldName: "customFldN07",
    dataType: "Double",
  },
  {
    fieldName: "customFldN08",
    dataType: "Double",
  },
  {
    fieldName: "customFldN09",
    dataType: "Double",
  },
  {
    fieldName: "customFldN10",
    dataType: "Double",
  },
  {
    fieldName: "customFldN11",
    dataType: "Double",
  },
  {
    fieldName: "customFldN12",
    dataType: "Double",
  },
  {
    fieldName: "customFldN13",
    dataType: "Double",
  },
  {
    fieldName: "customFldN14",
    dataType: "Double",
  },
  {
    fieldName: "customFldN15",
    dataType: "Double",
  },
  {
    fieldName: "customFldN16",
    dataType: "Double",
  },
  {
    fieldName: "customFldN17",
    dataType: "Double",
  },
  {
    fieldName: "customFldN18",
    dataType: "Double",
  },
  {
    fieldName: "customFldN19",
    dataType: "Double",
  },
  {
    fieldName: "customFldN20",
    dataType: "Double",
  },
  {
    fieldName: "phoneNumber",
    dataType: "String",
  },
  {
    fieldName: "phoneNumberMain",
    dataType: "Long",
  },
  {
    fieldName: "alternateContactNumber1",
    dataType: "Long",
  },
  {
    fieldName: "alternateContactNumber2",
    dataType: "Long",
  },
  {
    fieldName: "dob",
    dataType: "String",
  },
  {
    fieldName: "customFldD01",
    dataType: "String",
  },
  {
    fieldName: "customFldD02",
    dataType: "String",
  },
  {
    fieldName: "customFldD03",
    dataType: "String",
  },
  {
    fieldName: "customFldD04",
    dataType: "String",
  },
  {
    fieldName: "customFldD05",
    dataType: "String",
  },
  {
    fieldName: "customFldD06",
    dataType: "String",
  },
  {
    fieldName: "customFldD07",
    dataType: "String",
  },
  {
    fieldName: "customFldD08",
    dataType: "String",
  },
  {
    fieldName: "customFldD09",
    dataType: "String",
  },
  {
    fieldName: "customFldD10",
    dataType: "String",
  },
  {
    fieldName: "customFldD11",
    dataType: "String",
  },
  {
    fieldName: "customFldD12",
    dataType: "String",
  },
  {
    fieldName: "customFldD13",
    dataType: "String",
  },
  {
    fieldName: "customFldD14",
    dataType: "String",
  },
  {
    fieldName: "customFldD15",
    dataType: "String",
  },
  {
    fieldName: "customFldD16",
    dataType: "String",
  },
  {
    fieldName: "customFldD17",
    dataType: "String",
  },
  {
    fieldName: "customFldD18",
    dataType: "String",
  },
  {
    fieldName: "customFldD19",
    dataType: "String",
  },
  {
    fieldName: "customFldD20",
    dataType: "String",
  },
  {
    fieldName: "customFldDT01",
    dataType: "String",
  },
];

export default predefinedRows;
